__turbopack_context__.v({
  "closeButton": "NewOrderCardModal-module-scss-module__zXxncq__closeButton",
  "header": "NewOrderCardModal-module-scss-module__zXxncq__header",
  "headerText": "NewOrderCardModal-module-scss-module__zXxncq__headerText",
  "modal": "NewOrderCardModal-module-scss-module__zXxncq__modal",
});
